export default __webpack_public_path__ + "static/media/remove-icon.f77f20d6.svg";